import React, { useEffect } from 'react';
import UpcomingPCConsoleTable from './UpcomingPCConsoleTable';
import UpcomingMobileTable from './UpcomingMobileTable';
import { TopchartTableProps } from '@/pages/intelligence/pages/_config/topchartsInterface';

interface UpcomingTableProps extends TopchartTableProps {
  entityType: string;
  releaseTime: { startRelease: string; endRelease: string };
}
export default function UpcomingTable(props: UpcomingTableProps) {
  const { entityType } = props;
  if (entityType === 'mobile') {
    return <UpcomingMobileTable {...props} />;
  }
  return <UpcomingPCConsoleTable {...props} />;
}
